/**
 * Store Module - Product API Service
 *
 * Handles all HTTP calls to the product endpoints on the Go API.
 * Unwraps the { products: [...] } / { product: {...} } envelopes returned
 * by the API so callers always receive domain types directly.
 */

import apiClient from '../../../shared/lib/api'
import type { Product, ProductListResponse, ProductDetailResponse } from '../types/product'

const PRODUCTS_BASE = '/v1/products'

/**
 * Fetch the full product list.
 * Accepts an optional search string forwarded as ?search= query param.
 */
export async function listProducts(search?: string): Promise<Product[]> {
  const params = search ? { search } : undefined
  const response = await apiClient.get<ProductListResponse>(PRODUCTS_BASE, { params })
  return response.data.products
}

/**
 * Fetch a single product by ID.
 */
export async function getProduct(id: string): Promise<Product> {
  const response = await apiClient.get<ProductDetailResponse>(`${PRODUCTS_BASE}/${id}`)
  return response.data.product
}
